import {LocationSet} from '@emm/core/models/location-set.model';

export function locationSetsSort(val1: LocationSet, val2: LocationSet) {
    if (val1.name < val2.name) {
        return -1;
    }
    if (val1.name > val2.name) {
        return 1;
    }
    return 0;
}

export const genericSort = <T extends {}>(selector: (val: T) => string | number) => (
    val1: T,
    val2: T
) => {
    if (selector(val1) < selector(val2)) {
        return -1;
    }
    if (selector(val1) > selector(val2)) {
        return 1;
    }
    return 0;
};
